import { render, staticRenderFns } from "./is-loop.component.vue?vue&type=template&id=4f2d71f8"
import script from "./is-loop.component.ts?vue&type=script&lang=ts&external"
export * from "./is-loop.component.ts?vue&type=script&lang=ts&external"
import style0 from "./is-loop.component.vue?vue&type=style&index=0&id=4f2d71f8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2d71f8')) {
      api.createRecord('4f2d71f8', component.options)
    } else {
      api.reload('4f2d71f8', component.options)
    }
    module.hot.accept("./is-loop.component.vue?vue&type=template&id=4f2d71f8", function () {
      api.rerender('4f2d71f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/is-loop/is-loop.component.vue"
export default component.exports